// extracted by mini-css-extract-plugin
module.exports = {"root":"WaveBackground_root__3Iht7"};